import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface LogoProps {
    tone?: 'dark' | 'light'
    className?: string
    showTagline?: boolean
}

// The Rockwood mark: a single pitched roof over one level line, for level living
export const LogoMark: FC<{ tone?: 'dark' | 'light', className?: string }> = ({ tone = 'dark', className }): ReactNode => {
    return (
        <svg viewBox='0 0 32 32' aria-hidden='true' className={cn('shrink-0', className)}>
            <rect
                width='32'
                height='32'
                rx='8'
                className={cn('transition-[fill] duration-500', tone === 'light' ? 'fill-cream' : 'fill-forest')}
            />
            <path
                d='M8 16.5 16 9.5 24 16.5'
                fill='none'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
                className={cn('transition-[stroke] duration-500', tone === 'light' ? 'stroke-forest' : 'stroke-cream')}
            />
            <path
                d='M8 22.5h16'
                fill='none'
                strokeWidth='2'
                strokeLinecap='round'
                className={cn('transition-[stroke] duration-500', tone === 'light' ? 'stroke-forest' : 'stroke-cream')}
            />
        </svg>
    )
}

export const Logo: FC<LogoProps> = ({ tone = 'dark', className, showTagline = true }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-3', className)}>
            <LogoMark tone={tone} className='size-9' />

            <span className='flex flex-col leading-none'>
                <span className='font-heading text-[1.375rem] tracking-[0.01em]'>
                    Rockwood
                </span>

                {showTagline && (
                    <span className='mt-1.5 text-[0.5625rem] font-medium uppercase tracking-[0.42em] opacity-70'>
                        Estate · Hillcrest
                    </span>
                )}
            </span>
        </span>
    )
}
